import React from "react";
import ContentLoader from "react-content-loader"

import { WrapperLoader } from "./styles";

function PartnerLoader(props) {
    return (
        <WrapperLoader>
            <ContentLoader
                speed={1}
                viewBox="0 0 379 301"
                backgroundColor="#f3f3f3"
                foregroundColor="#e3e3e3"
                {...props}
            >
                <rect x="0" y="0" rx="2" ry="2" width="379" height="133" />
                <rect x="102" y="146" rx="2" ry="2" width="60" height="8" />
                <rect x="10" y="102" rx="2" ry="2" width="80" height="65" />
                <rect x="105" y="191" rx="2" ry="2" width="54" height="54" />
                <rect x="170" y="191" rx="2" ry="2" width="54" height="54" />
                <rect x="234" y="190" rx="2" ry="2" width="54" height="54" />
                <rect x="125" y="272" rx="2" ry="2" width="140" height="15" />
                <rect x="170" y="146" rx="2" ry="2" width="20" height="8" />
            </ContentLoader>
        </WrapperLoader>
    )
}

export default PartnerLoader;